import { render, staticRenderFns } from "./TemplateDetail.vue?vue&type=template&id=399b1254&scoped=true"
import script from "./TemplateDetail.vue?vue&type=script&lang=js"
export * from "./TemplateDetail.vue?vue&type=script&lang=js"
import style0 from "./TemplateDetail.vue?vue&type=style&index=0&id=399b1254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399b1254",
  null
  
)

export default component.exports